// extracted by mini-css-extract-plugin
export var box = "Footer-module--box--54ce3";
export var box_md = "Footer-module--box_md--e4db4";
export var box_xmd = "Footer-module--box_xmd--619ec";
export var box_flex = "Footer-module--box_flex--fb287";
export var box_lg = "Footer-module--box_lg--25a5b";
export var box_sm = "Footer-module--box_sm--e2486";
export var box_outer = "Footer-module--box_outer--aa097";
export var box_whiteBg = "Footer-module--box_white-bg--4b5f9";
export var box_noMarginBottom = "Footer-module--box_no-margin-bottom--b994a";
export var box_noPadding = "Footer-module--box_no-padding--5fcb0";
export var box_outerGray = "Footer-module--box_outer-gray--dc649";
export var box_dark = "Footer-module--box_dark--a6ce6";
export var box_zIndex = "Footer-module--box_z-index--3ce57";
export var box_zIndex6 = "Footer-module--box_z-index-6--f280d";
export var box_eventsWithLine = "Footer-module--box_events-with-line--0eed2";
export var box_featuresAo = "Footer-module--box_features-ao--46b32";
export var box_verticalPaddings = "Footer-module--box_vertical-paddings--5719f";
export var clearP = "Footer-module--clearP--ee15d";
export var clearP_vc = "Footer-module--clearP_vc--111c6";
export var footer = "Footer-module--footer--2d913";
export var wrapper = "Footer-module--wrapper--46564";
export var container = "Footer-module--container--70893";
export var title = "Footer-module--title--6d3c8";
export var main = "Footer-module--main--aada2";
export var line = "Footer-module--line--480f8";
export var line_without_top = "Footer-module--line_without_top--0281d";
export var popular = "Footer-module--popular--70d99";
export var linkContainer = "Footer-module--linkContainer--f4040";
export var linkItem = "Footer-module--linkItem--104ee";
export var link = "Footer-module--link--e0d8f";
export var linkAll = "Footer-module--linkAll--b8c48";
export var officeWrapper = "Footer-module--officeWrapper--0693a";
export var offices = "Footer-module--offices--6b487";
export var showRow = "Footer-module--showRow--2eaa1";
export var showMore = "Footer-module--showMore--c1ce9";
export var contactUs = "Footer-module--contactUs--ea73e";
export var fadeInAnimation = "Footer-module--fadeInAnimation--3b677";
export var placeHolderShimmer = "Footer-module--placeHolderShimmer--59fdc";